module.exports = __webpack_public_path__ + "img/photo.81e06bb7.svg";